import showcase from '@app/lang/reverse/fr/showcase';
import { COMMON_FR } from '@app/lang/reverse/fr/common';
import { SEARCHING_FR } from '@app/lang/reverse/fr/searching';
import { INTERVIEWING_FR } from '@app/lang/reverse/fr/interviewing';
import { CLOSING_FR } from '@app/lang/reverse/fr/closing';
import { SUCCESS_FEE_FR } from '@app/lang/reverse/fr/success-fee';
import { HOMEPAGE_FR } from '@app/lang/reverse/fr/homepage';
import { CANDIDATE_DETAILS_FR } from '@app/lang/reverse/fr/candidate-details';
import { ERRORS_FR } from '@app/lang/reverse/fr/errors';
import * as PROFILING_FR from '@app/lang/reverse/fr/profiling.json';
import * as LOGIN_FR from '@app/lang/reverse/fr/login.json';
import * as GLOBAL_COMPENSATION_FR from '@app/lang/reverse/fr/global-compensation.json';

const FR = {
  translation: {
    header: {
      welcome: 'Bienvenue',
      share: 'Partager',
      hide_compensation: 'Présenter avec la rémunération masquée',
      show_compensation: 'Afficher la rémunération',
    },
    hero: {
      backToHomepage: 'Tous vos services',
      backToHomepage_headHunter: 'Tous les services du client',
      prospect: {
        title: 'Calcul honoraire',
      },
      steps: {
        profiling: {
          title: 'Profil',
          title_no_miro: 'Contacts',
          description: 'Démarrage ',
        },
        searching: {
          title: 'Recherche',
          description: '1-10 JRS',
        },
        showcase: {
          title: 'Showcase',
          description: '11ᵉ JRS',
        },
        interviewing: {
          title: 'Entretiens',
          title_marketing: 'Talents',
          description: '11-20 JRS',
        },
        closing: {
          title: 'Engagements',
          description: 'Fin',
        },
      },
      helper: {
        profiling: {
          'to-do':
            "Bonjour. Voici notre processus, vous pouvez le consulter si vous le souhaitez. Vous serez toujours en mesure de consulter <strong>l'avancée de la recherche</strong>.",
          'to-do_withName':
            "Bonjour {{ name }}. Voici notre processus, vous pouvez le consulter si vous le souhaitez. Vous serez toujours en mesure de consulter <strong>l'avancée de la recherche</strong>.",
          doing: '$t(hero.helper.profiling.to-do)',
          doing_withName: '$t(hero.helper.profiling.to-do_withName)',
          done: '$t(hero.helper.profiling.to-do)',
          done_withName: '$t(hero.helper.profiling.to-do_withName)',
        },
        searching: {
          'to-do':
            "Pendant la recherche, <strong>vous pourrez voir les activités que nous réalisons pour vous</strong>, jusqu'à ce que des données plus précises soient disponibles.",
          doing:
            "Pendant la recherche, <strong>vous pourrez voir les activités que nous réalisons pour vous</strong>, jusqu'à ce que des données plus précises soient disponibles.",
          done: 'Nous avons présenté votre entreprise et le poste aux candidats. Voici <strong>ce que les chiffres nous disent</strong>.',
        },
        interviewing: {
          'to-do':
            'À ce stade, <strong>nous vous présenterons les candidats</strong> et nous aurons besoin de recevoir <strong>un retour en temps opportun</strong>.',
          doing:
            'Nous sommes au cœur du processus de sélection. Rappelons-nous : plus nous sommes réactifs, plus nous avons de chances de <strong>recruter</strong>.',
          done: 'Nous sommes au cœur du processus de sélection. Rappelons-nous : plus nous sommes réactifs, plus nous avons de chances de <strong>recruter</strong>.',
        },
        closing: {
          'to-do':
            "C'est la phase finale: la plus délicate. <strong>Négociation, démission et onboarding</strong>.",
          doing:
            "C'est la phase finale: la plus délicate. <strong>Négociation, démission et onboarding</strong>.",
          done: "C'est la phase finale: la plus délicate. <strong>Négociation, démission et onboarding</strong>.",
        },
        marketing: {
          profiling: {
            'to-do':
              'Bonjour. Sur ces pages, vous pouvez voir les <strong>talents que nous avons sélectionnés pour vous</strong> et si vous décidez de les rencontrer, <strong>tout sur leur statut dans le processus de sélection</strong>.',
            'to-do_withName':
              'Bonjour {{ name }}. Sur ces pages, vous pouvez voir les <strong>talents que nous avons sélectionnés pour vous</strong> et si vous décidez de les rencontrer, <strong>tout sur leur statut dans le processus de sélection</strong>.',
            doing: '$t(hero.helper.marketing.profiling.to-do)',
            doing_withName:
              '$t(hero.helper.marketing.profiling.to-do_withName)',
            done: '$t(hero.helper.marketing.profiling.to-do)',
            done_withName: '$t(hero.helper.marketing.profiling.to-do_withName)',
          },
          interviewing: {
            'to-do':
              'Dès que des talents susceptibles de <strong>te convenir</strong> seront identifiés, tu les trouveras ici.',
            doing:
              "Les candidats intéressants ne restent pas disponibles longtemps. <strong>Ne manque pas l'occasion de les rencontrer</strong>.",
            done: '$t(hero.helper.marketing.interviewing.doing)',
          },
        },
      },
    },
    profile: {
      contract: {
        title: 'Vous trouvez ici le contrat pour ce mandat',
        title_marketing:
          'Découvrez les meilleurs talents,<br/>ne payez que lorsque vous embauchez.',
        download: 'Téléchargez le contrat',
      },
      references: {
        title: 'Vos contacts',
        blank: {
          title: 'Nous recherchons la bonne personne pour cette recherche',
          text: 'Nous voulons le meilleur HR Consultant dont nous disposons...',
        },
      },
      mirror: {
        body: '<strong>Une nouvelle approche pour le recrutement</strong><br><br>FLEXIBLE, DIGITALE ET SPÉCIALISÉE.',
        link: 'Découvrez le recrutement collaboratif',
      },
    },
    general: {
      error: {
        title: "Une erreur s'est produite.",
        subtitle:
          "Veuillez rafraîchir la page. Si le problème n'est pas résolu, réessayez plus tard.",
        hash: {
          title: 'Le lien a expiré.',
          subtitle:
            "Vous devriez avoir reçu le <strong>bon lien</strong> dans l'un de <strong>nos récents e-mails</strong>.",
          disclaimer:
            'Vous ne le trouvez pas ? <strong>Veuillez informer vos personnes de contact</strong>',
        },
        unauthorized: {
          title: 'Ce lien semble incorrect.',
          subtitle:
            'Vous devriez avoir reçu le <strong>lien correct</strong> dans un <strong>e-mail de notre part</strong> peu après avoir <strong>signé le contrat</strong>.',
          disclaimer:
            'Vous ne le trouvez pas ? <strong>Veuillez informer vos personnes de contact</strong>',
        },
        unauthorizedHomepage: {
          title: "Vous n'êtes pas autorisé à afficher cette page.",
          subtitle: '',
          disclaimer: '',
        },
      },
      document_title: {
        profiling: 'Profil',
        searching: 'Recherche',
        interviewing: 'Entretiens',
        closing: 'Clôture',
        showcase: 'Showcase',
      },
      document_title_reverse_marketing: {
        profiling: '$t(hero.steps.profiling.title_no_miro)',
        searching: '$t(hero.steps.searching.title)',
        interviewing: '$t(hero.steps.interviewing.title_marketing)',
        closing: '$t(hero.steps.closing.title)',
        showcase: '$t(hero.steps.showcase.title)',
      },
      date_on: 'le',
      date_hour: 'à',
    },
    candidate: {
      hero: {
        title: 'vous recherchez:',
        back_label: 'Retour',
      },
      infos: {
        age: 'années',
        benefits: 'Avantages actuels',
        bonuses: 'Primes actuelles',
      },
      sections: {
        horse: {
          title: 'Situation actuelle',
        },
        bet: {
          open_chat: 'Écrivez en chat à <strong>{{ name }}</strong>',
        },
        curriculum: {
          title: 'Curriculum Vitae',
          screening: 'Évaluation de présélection ',
          button: 'Consultez le CV',
        },
        summary: {
          otherSelectionsTitle: 'Autres processus de sélection',
        },
        concerns: {
          intro:
            '{{ name }} est un profil très intéressant mais pas tout à fait aligné avec les prérequis.',
        },
      },
    },
    footer: {
      company: 'Reverse France SAS',
      headquarter: 'Siège social: 29 rue Blanche 75009 Paris',
      informations: [
        'SIRET: 910 505 684 00019',
        'VAT: FR71910505684',
        'Pec: reversespa@pec.it',
        'Capitale sociale libéré: 50.000€',
      ],
      menu: {
        contact: {
          label: 'Nous contacter',
          slug: 'nous contacter',
        },
        legal: {
          label: 'Legal',
          slug: 'legal',
        },
        cookies: {
          label: 'Cookies',
          url: 'https://www.iubenda.com/privacy-policy/80643942/cookie-policy',
        },
      },
    },
    modal: {
      share: {
        title: "Partager l'avancement du recrutement avec d'autres",
        inputs: {
          first_name: {
            label: 'Prénom',
            placeholder: 'Prénom',
          },
          last_name: {
            label: 'Nom',
            placeholder: 'Nom',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
            hint: "L'e-mail ne correspond pas au domaine sur lequel vous êtes enregistré. Voulez-vous vraiment continuer?",
          },
          lang: {
            label: 'Langue',
            placeholder: 'Sélectionner la langue',
          },
        },
        isCompensationPackageVisible: {
          label:
            'Permettre à la personne invitée de consulter <strong>les packages de rémunération</strong> des candidats.',
        },
        lang_options: {
          it: 'Italien',
          en: 'Anglais',
          de: 'Allemand',
          fr: 'Français',
          es: 'Espagnol',
        },
        button: 'Inviter',
        shared_with: 'Partagé avec',
        alert: {
          positive: "L'invitation par e-mail a été envoyée",
          negative:
            'Quelque chose a mal tourné. Veuillez réessayer plus tard ou contacter vos personnes de contact',
          guest_info:
            'La personne invitée ne pourra pas voir les packages de rémunération des candidats. Si elle a besoin d’accéder à ces informations, demandez à {{ mainClient }} ou au recruteur d’activer les autorisations.',
        },
        table: {
          header: {
            name: 'Nom',
            email: 'E-mail',
            compensationVisibility: 'Visibilité de la rémunération',
          },
          guest: '(Invité)',
          mainClient: '(Client principal)',
        },
      },
    },
    validation: {
      scout_approved: 'Validé par un scout',
      scout_required: 'Nécessite la validation des scouts',
      required: 'Ce champ est obligatoire',
      email: "Cette adresse e-mail n'est pas valide",
    },
    language_switcher: {
      it: 'IT',
      en: 'EN',
      de: 'DE',
      fr: 'FR',
      es: 'ES',
    },
    showcase,
    candidateDetails: CANDIDATE_DETAILS_FR,
    common: COMMON_FR,
    searching: SEARCHING_FR,
    interviewing: INTERVIEWING_FR,
    closing: CLOSING_FR,
    successFee: SUCCESS_FEE_FR,
    globalCompensation: GLOBAL_COMPENSATION_FR,
    homepage: HOMEPAGE_FR,
    login: LOGIN_FR,
    profiling: PROFILING_FR,
    errors: ERRORS_FR,
  },
};

export default FR;
